import { createBrowserHistory, createMemoryHistory } from "history";
export const history = createBrowserHistory();

// const isTest = process.env.NODE_ENV === "test";
// export const history = isTest
//   ? createMemoryHistory({ initialEntries: ['/'] })
//   : createBrowserHistory();
